/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

function LaboratoryIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_600_1469" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="43" height="43">
        <rect x="0.666626" y="0.5" width="42" height="42" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_600_1469)">
        <path d="M9.41663 36.375C8.30042 36.375 7.50705 35.8769 7.0365 34.8808C6.56593 33.8846 6.67952 32.9581 7.37727 32.101L17.2917 20.0529V9.25H15.2052C14.8333 9.25 14.5216 9.12416 14.27 8.87248C14.0184 8.62083 13.8927 8.30898 13.8927 7.93693C13.8927 7.56491 14.0184 7.25327 14.27 7.002C14.5216 6.7507 14.8333 6.62505 15.2052 6.62505H28.1281C28.5 6.62505 28.8117 6.75089 29.0633 7.00257C29.3148 7.25424 29.4406 7.56609 29.4406 7.93811C29.4406 8.31016 29.3148 8.62183 29.0633 8.8731C28.8117 9.12437 28.5 9.25 28.1281 9.25H26.0416V20.0529L35.956 32.101C36.6538 32.9581 36.7673 33.8846 36.2968 34.8808C35.8262 35.8769 35.0328 36.375 33.9166 36.375H9.41663Z" fill="currentColor" />
      </g>
    </svg>
  );
}

export default LaboratoryIcon;
